import bitwise from "./bitwise";
import { pick, omit } from './JSONObject'

export {
    bitwise,
    pick,
    omit
}



// WEBPACK FOOTER //
// ./src/utils/index.js